<script>
import { productDetailImageSlider, relatedProductSlider } from './../../../static/js/main_vue.js';

import { ShoppingCart, Location } from './../../functions.js';

import ProductAPI from './../../api/product.js';

import HeaderFive from './../shared/HeaderFive.vue';
import Footer from './../shared/Footer.vue';
import ProductCard from './../shared/ProductCard.vue';
import AddToCartModal from './../shared/AddToCartModal.vue';
import AddToCartDialogue from './../shared/AddToCartDialogue.vue';
import QuickviewDialogue from './../shared/QuickviewDialogue.vue';

export default {
  name: 'productDetails',
  components: {
    ProductCard,
    Footer,
    HeaderFive,
    AddToCartModal,
    AddToCartDialogue,
    QuickviewDialogue
  },
  data () {
    return {
      loading: true,
      product_data: null,
      ratings: 0,
      reviews: [],
      product_name: '',
      product_price: 0,
      sale_type: '',
      sale_price: 0,
      product_original_price: 0,
      category: '',
      stock_on_hand: '',
      quantity: 1,
      images: [],
      product_description: '',
      related_products: [],
      showAddToCartModal: false,
      modal_status: "success",
      modal_custom_message: "",
    }
  },
  methods: {
      isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      plus()
      {
        if(this.quantity < parseInt(this.stock_on_hand))
          this.quantity += 1;
      },
      minus()
      {
          this.quantity = (this.quantity > 1 ? this.quantity-=1 : 1);
      },
      addToCart()
      {
          ShoppingCart.addToCart(this.product_data, this.quantity).then((response)=>{
            this.modal_status = (response.status == 'success' ? 'success' : 'failed');
            this.modal_custom_message = (response.status == 'success' ? '' : response.message);
            if(response.status == 'success')
            {
              this.quantity = 1;
            }
            this.showAddToCartModal = true;
          });
      },
      async loadProductDetails()
      {
          this.loading = true;
          setTimeout(() => {
            try {

              var sku_id = (this.$route.params.sku_id ? this.$route.params.sku_id : '');
              var sku_name = (this.$route.params.sku_name ? this.$route.params.sku_name : '');
      
              if(sku_id == "" || sku_name == "")
              {
                  // If there's no sku id or name, redirect to shop page 
                this.loading = false;
                this.$router.push("/shop");
              }
              else
              {
                  var barangay_code = Location.location.barangay.brgy_code;
                  var productdetails_request = ProductAPI.getProductDetails(barangay_code, sku_id)
                  productdetails_request.then((response) => {
                   if(response.status)
                   {
                       this.product_data = response.product;
                       this.product_name = response.product.product_name;
                       this.product_price = response.product.product_price;
                       this.product_original_price = response.product.original_price;
                       this.category = response.product.main_category_name;
                       this.images = response.product.product_image;
                       this.product_description = response.product.product_description;
                       this.sale_type = response.product.sale_type;
                       this.sale_price = response.product.sale_price;
                       this.stock_on_hand = response.product.stock_on_hand;

                       if(this.images.length > 1)
                       {
                         setTimeout(()=>{
                          productDetailImageSlider();
                         }, 1000);
                       }


                       this.related_products = response.related_products;
                   }

                    this.loading = false
                  });

                  // var productreview_request = ProductAPI.getProductReview(sku_id)
                  // productreview_request.then((response) => {
                  //   console.log(response);

                  //   this.loading = false
                  // });

              }
            } catch (error) {
              this.loading = false
              console.log(error)
            }
          }, 500)
      },
       getProductPrice(product)
    {
      if(product.sale_type == 'default')
      {
        return (product.product_price);
      }
      else
      {
       
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo))
              {
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }
          
          if(has_price_off_promo)
          {
            var passed_product_requirements = 0;
            product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
              ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                if(p.product.sku == ri.sku_id)
                {
                  passed_product_requirements+=1;
                }
              });
            });

            if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
            {

               if(product.promo[price_off_promo_index].promo_minimum_amount)
                {
                  return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
                }
                else
                {
                   return (product.sale_price);
                }
            }
            else
            {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
            }

          }
          else
          {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
          }

       

      }
     

      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo))
      //       {
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });
          
      //     if(has_price_off_promo)
      //     {
      //       var passed_product_requirements = 0;
      //       product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //         ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //           if(p.product.sku == ri.sku_id)
      //           {
      //             passed_product_requirements+=1;
      //           }
      //         });
      //       });

      //       if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //       {

      //          if(product.promo[price_off_promo_index].promo_minimum_amount)
      //           {

      //             return (product.product_price);
      //           }
      //           else
      //           {

      //             return  (product.sale_price );
      //           }
      //       }
      //       else
      //       {

      //         return  (product.product_price);
      //       }

      //     }
      //     else
      //     {

      //         return (product.product_price);
      //     }

      //   }
      //   else
      //   {
      //     return (product.sale_price);
      //   }

      // }
      // else
      // {
      //   return (product.product_price);
      // }

    },
    hasProductPromo(product)
    {

      if(product.promo && product.promo.length)
      {
         return true;
      }
      else
      {
        return null;
      }

    },
    getProductSlashedPrice(product)
    {

      if(product.sale_type == 'default')
      {
        return 0;
      }
      else
      {
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)){
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }


          if(has_price_off_promo)
          {
              var passed_product_requirements = 0;
              product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                  if(p.product.sku == ri.sku_id)
                  {
                    passed_product_requirements+=1;
                  }
                });
              });

              if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
              {
                  if(product.promo[price_off_promo_index].promo_minimum_amount)
                  {
                    return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
                  }
                  else
                  {
                    return (product.original_price);
                  }
                 
              }
              else
              {
                return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
              }
         

          }
          else
          {
           return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
          }

        }

    


      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo)){
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });


      //     if(has_price_off_promo)
      //     {
      //         var passed_product_requirements = 0;
      //         product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //             if(p.product.sku == ri.sku_id)
      //             {
      //               passed_product_requirements+=1;
      //             }
      //           });
      //         });

      //         if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //         {
      //             if(product.promo[price_off_promo_index].promo_minimum_amount)
      //             {
      //               return  0;
      //             }
      //             else
      //             {
      //               return  (product.original_price);
      //             }
                 
      //         }
      //         else
      //         {
      //           return  (0);
      //         }
         

      //     }
      //     else
      //     {
      //       return (0);
      //     }

      //   }
      //   else
      //   {
      //     return (product.original_price);
      //   }

      // }
      // else
      // {
      //   return (0);
      // }
    }
  },
  mounted()
  {
      relatedProductSlider();

      this.loadProductDetails();
  }
}
</script>

<template>
  <div class="page product-details-page">
    <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="/static/img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            
                            <h1 class="section-title white-color">Product Details</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Product Details</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- SHOP DETAILS AREA START -->
    <div class="ltn__shop-details-area pb-85" v-if="!loading">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="ltn__shop-details-inner mb-60">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="ltn__shop-details-img-gallery">
                                    <div class="ltn__shop-details-large-img">
                                        <div class="single-large-img" v-for="image in images">
                                            <a :href="image" data-rel="lightcase:myCollection">
                                                <img :src="image" alt="Image">
                                            </a>
                                        </div>
                                        
                                    </div>
                                    <div class="ltn__shop-details-small-img slick-arrow-2" v-if="images.length > 1">
                                        <div class="single-small-img"  v-for="image in images">
                                            <img :src="image" alt="Image">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="modal-product-info shop-details-info pl-0">
                                    <!-- <div class="product-ratting">
                                        <ul>
                                            <li><a href="#"><i class="fas fa-star"></i></a></li>
                                            <li><a href="#"><i class="fas fa-star"></i></a></li>
                                            <li><a href="#"><i class="fas fa-star"></i></a></li>
                                            <li><a href="#"><i class="fas fa-star-half-alt"></i></a></li>
                                            <li><a href="#"><i class="far fa-star"></i></a></li>
                                            <li class="review-total"> <a href="#"> ( {{ reviews.length }} Reviews )</a></li>
                                        </ul>
                                    </div> -->
                                    <h3>{{ product_name }}</h3>
                                       <div class="product-price">
                                          <span>
                                            {{ getProductPrice(product_data) | currencyFormat }} </span>
                                          <del  v-if=" getProductSlashedPrice(product_data) > 0">
                                          <span >{{ getProductSlashedPrice(product_data) | currencyFormat }}</span>
                                          </del>
                                      </div>
                                    <div class="promo-details" v-if="hasProductPromo(product_data)">
                                     <small v-for="promo of product_data.promo">{{  promo.promo_description }}<br></small>
                                   </div>
                                    <div class="modal-product-meta ltn__product-details-menu-1">
                                      <!--   <ul>
                                            <li>
                                                <strong>Category:</strong>
                                                <span>
                                                    <a href="#">{{ category }}</a>
                                                </span>
                                            </li>
                                        </ul> -->
                                        <small>({{ stock_on_hand }} Available)</small>
                                    </div>
                                    <div class="ltn__product-details-menu-2">
                                        <ul>
                                            <li>
                                                <div class="cart-plus-minus">
                                                   <div class="dec qtybutton" @click="minus">-</div>
                                                    <input type="text" v-model="quantity" @keypress="isNumber($event)" name="qtybutton" class="cart-plus-minus-box">
                                                    <div class="inc qtybutton" @click="plus">+</div>
                                                </div>
                                            </li>
                                            <li>
                                                <a href="#" class="theme-btn-1 btn btn-effect-1" title="Add to Cart" @click="addToCart">
                                                    <i class="fas fa-shopping-cart"></i>
                                                    <span>ADD TO CART</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ltn__product-details-menu-3">
                                        <!-- <ul>
                                            <li>
                                                <a href="#" class="" title="Wishlist" data-toggle="modal" data-target="#liton_wishlist_modal">
                                                    <i class="far fa-heart"></i>
                                                    <span>Add to Wishlist</span>
                                                </a>
                                            </li>
                                        </ul> -->
                                    </div>
                                    <hr>
                                    <div class="ltn__social-media">
                                        <ul>
                                            <li>Share:</li>
                                            <li><a href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="#" title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
                                            <li><a href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li>

                                        </ul>
                                    </div>
                                    <hr>
                                    <!-- <div class="ltn__safe-checkout">
                                        <h5>Guaranteed Safe Checkout</h5>
                                        <img src="/static/img/icons/payment-2.png" alt="Payment Image">
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Shop Tab Start -->
                    <div class="ltn__shop-details-tab-inner ltn__shop-details-tab-inner-2">
                        <div class="ltn__shop-details-tab-menu">
                            <div class="nav">
                                <a class="active show" data-toggle="tab" href="#liton_tab_details_1_1">Description</a>
                               
                            </div>
                        </div>
                        <div class="tab-content">
                            <div class="tab-pane fade active show" id="liton_tab_details_1_1">
                                <div class="ltn__shop-details-tab-content-inner">
                                    <!-- <h4 class="title-2">Lorem ipsum dolor sit amet elit.</h4> -->
                                    <p>{{ product_description }}</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <!-- Shop Tab End -->
                </div>
              
            </div>
        </div>
    </div>
    <!-- SHOP DETAILS AREA END -->

    <!-- PRODUCT SLIDER AREA START -->
    <div class="ltn__product-slider-area ltn__product-gutter pb-70" v-if="related_products.length">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area ltn__section-title-2">
                        <!-- <h6 class="section-subtitle ltn__secondary-color">//  cars</h6> -->
                        <h1 class="section-title">Related Products<span>.</span></h1>
                    </div>
                </div>
            </div>
            <div class="row ltn__related-product-slider-one-active slick-arrow-1">
                <!-- ltn__product-item -->
                <div class="col-lg-3" v-for="relate_product in related_products">
                    <ProductCard
                    :product="relate_product"
                    :id="relate_product.id"
                    :name="relate_product.title"
                    :badge="relate_product.discountPercentage"
                    :rating="relate_product.rating"
                    :price="relate_product.price"
                    :sale-price="relate_product.price"
                    @onQuickview="quickview(relate_product)"
                    @onAddToCart="showModal()"
                    @onAddToWishlist="showModal()" />
                </div>
               
                <!--  -->
            </div>
        </div>
    </div>
    <!-- PRODUCT SLIDER AREA END -->
    <AddToCartModal :product="product_data" :status="modal_status" :message="modal_custom_message" v-if="showAddToCartModal"  @onClose="showAddToCartModal = false" />
     <AddToCartDialogue ref="addToCartDialogue" />
    <QuickviewDialogue ref="quickviewDialogue" />
    <Footer />
  </div>
</template>
<style scoped>
.promo-details {
    font-size: 1rem !important;
    color: red;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ProductDetails.vue